import { ReactElement } from 'react';
import SignupForm from './components/SignupForm';
import { HeadTag } from 'shared/components';

const SignupPage = (): ReactElement => (
    <>
        <HeadTag title="Signup" />
        <SignupForm />
    </>
);

export default SignupPage;
